import { ContactCompanyType } from 'models/contact_companies'
import { DataTableColumnSort } from '../../../../DataTable/DataTableSorting/DataTableSortingStore'
import { useGooglePlacesBaseTableCols } from '../../GooglePlaceBase/GooglePlaceBaseTable/GooglePlaceBaseTableColumns'
import { CONVENIENCE_COLUMNS } from '../ConvenienceColumnsInfo'

export const useConvenienceTableCols = ({
  sorting,
  inCampaigns,
}: {
  sorting?: DataTableColumnSort[]
  inCampaigns?: boolean
}) => {
  const commonColumns = useGooglePlacesBaseTableCols({
    sorting,
    inCampaigns,
    accesor: 'cstore',
    tableColumns: CONVENIENCE_COLUMNS,
    linkPrefix: 'convenience/chain',
    companyType: ContactCompanyType.Convenience,
  })
  return commonColumns
}
